module.exports = __webpack_public_path__ + "media/images/icons/more_green-85a88866a90c130a7a0b4c666ad660aa.svg";